import styled, { css, keyframes } from 'styled-components';
import { RAIL_LOGO_CENTER } from './sidebarRail.constants';
import { duration } from '@stylesheets/motion';

const handleIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.85);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

// Positioned on a wrapper: the Tooltip's inline span would otherwise become the containing block.
export const Anchor = styled.div`
  position: absolute;
  top: ${RAIL_LOGO_CENTER}px;
  left: 100%;
  z-index: 1100;
  transform: translate(-50%, -50%);
`;

export const Handle = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 34px;
  padding: 0;
  cursor: pointer;
  animation: ${handleIn} 240ms cubic-bezier(0.4, 0, 0.2, 1);

  ${({ theme: { colors, borderRadius } }) => css`
    border: 1px solid ${colors.shellDivider};
    border-radius: ${borderRadius.full};
    background: ${colors.surface};
    color: ${colors.onSurfaceVariant};
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
    transition:
      background-color ${duration.fast} ease,
      color ${duration.fast} ease;

    &:hover {
      background: ${colors.surfaceContainerHigh};
      color: ${colors.onSurface};
    }

    &:focus-visible {
      outline: 2px solid ${colors.primary};
      outline-offset: 2px;
    }
  `}

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;
